import { IRootState } from '../../../store'
import { IPatientMedicalHistoryState } from '../store/patientMedicalHistory.types'

export const getPatientMedicalHistorySelector = (state: IRootState): IPatientMedicalHistoryState =>
  state.patientMedicalHistory
